export const portfolioPackages = [
    {
        id: "konut",
        slug: "konut",
        cardTitle: "KONUT",
        cardSummary: "Yüksek katlı ve villa projeleri için interior + exterior setler.",
        title: "Konut Görselleştirme Paketi",
        meta: ["8K render", "Animasyon", "3ds Max • Corona"],
        body: [
            "Satış ofislerinde, yarışma sunumlarında ve online lansmanlarda kullanılmak üzere konut projelerini günün farklı saatlerinde yeniden kurguluyoruz. Exterior ve interior sahneler aynı ışık planına bağlı olduğu için tutarlı bir hikâye elde ediliyor.",
            "Proje başlangıcında BIM/Revit modellerini optimize ediyor, peyzajı yerel bitki kütüphanesiyle zenginleştiriyor ve her daire tipine özel iç mekan stilleri hazırlıyoruz. Render sonrası renk düzenlemeleri ACES üretim akışı ile sağlanıyor.",
        ],
        ctaLabel: "Brief göndermek",
        ctaUrl: "mailto:studio@modelerman.com?subject=Konut%20Archviz%20Brief",
        orderIndex: 0,
        published: true,
    },
    {
        id: "peyzaj",
        slug: "peyzaj",
        cardTitle: "PEYZAJ",
        cardSummary: "Kentsel peyzaj, rekreasyon ve waterfront masterplan sahneleri.",
        title: "Peyzaj & Masterplan Sunumları",
        meta: ["Panoramik", "Drone eşleştirme", "Unreal • Rail Clone"],
        body: [
            "Kentsel dönüşüm, sahil düzenleme ve rekreasyon projelerinde 360° panoramik görseller, etkileşimli dokunuşlar ve drone çekimlerine entegre render setleri üretiyoruz. Böylece yatırımcılar maket üzerinde dolaşır gibi tasarımı deneyimliyor.",
            "Bitkilendirme senaryolarını mevsimsel varyasyonlarıyla hazırlıyor, crowd simülasyonları ile alan kullanım yoğunluğunu görselleştiriyoruz. İstenirse Unreal Engine üzerinden canlı sunum paketi oluşturuyoruz.",
        ],
        ctaLabel: "Görüşme planla",
        ctaUrl: "mailto:studio@modelerman.com?subject=Peyzaj%20Sunum%20Talebi",
        orderIndex: 1,
        published: true,
    },
    {
        id: "ic-mekan",
        slug: "ic-mekan",
        cardTitle: "İÇ MEKAN",
        cardSummary: "Satış galerisi ve örnek daire için stilize edilmiş iç mekan kurguları.",
        title: "İç Mekan Stilizasyonu",
        meta: ["8K still", "Storyboard", "Blender • Cycles"],
        body: [
            "Örnek daire, lobi, satış galerisi ve sosyal alanlar için materyal araştırması, ışık senaryosu ve dekorasyon kurgusu sağlıyoruz. Fotoğraf ekibiyle birlikte çalışarak renderların gerçek çekimlerle birebir eşleşmesini hedefliyoruz.",
            "Stil rehberi, moodboard ve ürün seçim listeleri teslim paketine dahil. İsteğe bağlı olarak render sonrası AR filtrasyonu ve dokunmatik satış ekranlarına uygun etkileşimli içerikler hazırlıyoruz.",
        ],
        ctaLabel: "Paket talep et",
        ctaUrl: "mailto:studio@modelerman.com?subject=%C4%B0%C3%A7%20Mekan%20Render%20Talebi",
        orderIndex: 2,
        published: true,
    },
    {
        id: "animasyon",
        slug: "animasyon",
        cardTitle: "ANİMASYON",
        cardSummary: "Gün doğumundan gece ışıklandırmasına kadar hikayesel kamera rotaları.",
        title: "Hareketli Sunum & Animasyon",
        meta: ["4K video", "Sinematik kamera", "Unreal Sequencer"],
        body: [
            "Projenizi gün doğumundan gece ışıklandırmasına kadar anlatan sinematik rotalar tasarlıyoruz. Dronela çekilmiş görüntülerle CG sahneleri match moving tekniğiyle birleştirerek gerçekliğe yakın animasyonlar ortaya çıkarıyoruz.",
            "Teslim formatı; sosyal medya, LED duvar ve televizyon yayınlarına uygun olarak farklı kırpma oranlarında hazırlanıyor. Ses tasarımı, yönlendirme metni ve altyazı paketleri opsiyonel.",
        ],
        ctaLabel: "Örnek animasyon iste",
        ctaUrl: "mailto:studio@modelerman.com?subject=Animasyon%20Sunum%20Talebi",
        orderIndex: 3,
        published: true,
    },
];
